import * as authConstants from '../authConstants';
import * as metaStateUtils from '../../../../store/util/metaStateUtils';

import saveTokenReducer from './saveTokenReducer';


const INITIAL_STATE = metaStateUtils.withDefaultMetaState({
    token: {}
});


export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case authConstants.ACTION_AUTH_SUCCESSFUL:
        case authConstants.ACTION_AUTH_REFRESH_SUCCESSFUL:

            return saveTokenReducer(state, action.payload);


        case authConstants.ACTION_AUTH_LOGOUT:

            state.token = {};

            return state;


        default:

            return state;
    }
};
